const MANUAL_GRANT_GUIDE_ASSETS = {
    clt027: '/subvencions-data/clt027/guide.json',
};

export function getManualGrantGuideAsset(slug) {
    const normalizedSlug = String(slug || '').toLowerCase();
    return MANUAL_GRANT_GUIDE_ASSETS[normalizedSlug] || null;
}

async function fetchJsonAsset(assetPath) {
    const response = await fetch(assetPath, {
        cache: 'no-store',
    });

    if (!response.ok) {
        throw new Error(`No s'ha pogut carregar la guia manual (${response.status})`);
    }

    return response.json();
}

export async function loadManualGrantGuide(slug) {
    const assetPath = getManualGrantGuideAsset(slug);

    if (!assetPath) {
        return null;
    }

    return fetchJsonAsset(assetPath);
}

export function mergeManualGrantGuide(detail, guideDefinition) {
    if (!detail || !guideDefinition?.guide) {
        return detail;
    }

    return {
        ...detail,
        edition: {
            ...detail.edition,
            callYear: null,
            status: null,
            statusLabel: null,
            dateRangeLabel: null,
            openAt: null,
            closeAt: null,
            closeTimeLabel: null,
            isHistorical: false,
            guideStatus: 'manual',
        },
        history: [],
        guide: guideDefinition.guide,
        sources: guideDefinition.sources || [],
    };
}
